import { Routes } from '@angular/router';
import { apiAuthGuard } from '@saexpeditions/sdk/authentication';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'login',
    loadComponent: () => import('./pages/public/login/login.page').then((m) => m.LoginPage),
  },
  {
    path: 'secure',
    canActivate: [apiAuthGuard()],
    loadChildren: () => import('./pages/secure/secure-layout.routes').then((m) => m.secureRoutes),
  },
  {
    path: '**',
    redirectTo: 'login',
  },
];
